module.exports = __webpack_public_path__ + "static/media/Oneer.9d68341a.ttf";